// import { defineStore } from 'pinia'
// import { ref } from 'vue'
import { useCollection } from "vuefire"
import Handlebars from "handlebars"
import { writeBatch, doc, setDoc, deleteDoc, collection, updateDoc } from "firebase/firestore"
import langs_defs_file from "@/static/langs.json"

export const useLangsStore = defineStore("langs", () => {
	const db = useFirestore()
	const DataStore = useDataStore()
	const langs_missing = ref(<tsAppendableObj>[])

	Handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
		switch (operator) {
			case "==":
				return v1 == v2 ? options.fn(this) : options.inverse(this)
			case "===":
				return v1 === v2 ? options.fn(this) : options.inverse(this)
			case "!=":
				return v1 != v2 ? options.fn(this) : options.inverse(this)
			case "!==":
				return v1 !== v2 ? options.fn(this) : options.inverse(this)
			case "<":
				return v1 < v2 ? options.fn(this) : options.inverse(this)
			case "<=":
				return v1 <= v2 ? options.fn(this) : options.inverse(this)
			case ">":
				return v1 > v2 ? options.fn(this) : options.inverse(this)
			case ">=":
				return v1 >= v2 ? options.fn(this) : options.inverse(this)
			case "&&":
				return v1 && v2 ? options.fn(this) : options.inverse(this)
			case "||":
				return v1 || v2 ? options.fn(this) : options.inverse(this)
			default:
				return options.inverse(this)
		}
	})
	function getHandlebarText(strTemplate: string, objPayload: tsAppendableObj) {
		const template = Handlebars.compile(strTemplate)
		return template(objPayload)
	}
	function getHandlebarLangs(strTemplate: string, arrLangsKeys: Array<string>, lang?: string) {
		const objPayload: tsAppendableObj = {}
		for (const strLangKey of arrLangsKeys) {
			objPayload[strLangKey] = getLangEntry(strLangKey, lang)
		}
		return getHandlebarText(strTemplate, objPayload)
	}
	//

	// const lang_id = ref(<string>"en")

	const langs_ids = ref(["en", "ro"])
	// const { $getQParDef } = useNuxtApp()
	const context = ref({ lang_filter: "", lang_id: "ro" }) //
	const disabled_reset_langs = ref(false)

	function changeLang(lang_id_set: string) {
		if (!lang_id_set) lang_id_set = context.value.lang_id

		if (context.value.lang_id !== lang_id_set) {
			context.value.lang_id = lang_id_set
		}
		// console.log("changeLang", context.value.lang_id)
		setPathPar(context.value, "lang_id", 1)
	}

	async function reset() {
		// disabled_reset_langs.value = true
		// const db = useFirestore()
		// // Get a new write batch
		// const batch = writeBatch(db)
		// for (const lang_entry of langs_defs.value) {
		// 	// console.log(lang_entry)
		// 	const lang_ref = doc(db, 'langs', lang_entry.id)
		// 	batch.set(lang_ref, lang_entry)
		// }
		// // Commit the batch
		// await batch.commit()
		// disabled_reset_langs.value = false
	}

	const getAllLangs = <tsAppendableObj>() => {
		const out = <tsAppendableObj>langs_defs_file

		if (DataStore.langs_entries)
			// if (DataStore.holders_vuefire["base_langs"] && DataStore.holders_vuefire["base_langs"].length > 0) {
			// 	out["base_langs"] = DataStore.holders_vuefire["base_langs"].reduce((acc: tsAppendableObj, current, index) => {
			// 		acc[current.id] = current
			// 		return acc
			// 	}, {})
			// 	// console.log(out["base_langs"])
			// }
			// if (DataStore.holders_vuefire["main_langs"] && DataStore.holders_vuefire["main_langs"].length > 0) {
			// 	out["main_langs"] = DataStore.holders_vuefire["main_langs"].reduce((acc: tsAppendableObj, current, index) => {
			// 		acc[current.id] = current
			// 		return acc
			// 	}, {})
			// 	// console.log(out["main_langs"])
			// }
			// console.log(out)
			return out
	}

	function getLangEntry(lang_context: string, lang_key: string, lang?: string) {
		if (!lang) lang = context.value.lang_id
		// console.log(DataStore.langs_entries)
		const allLangs =
			DataStore.langs_entries && DataStore.langs_entries[lang_context] ? DataStore.langs_entries : langs_defs_file

		// console.log("zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz", allLangs[lang_context][lang_key])

		const lang_entry = allLangs[lang_context][lang_key]

		if (lang_entry && lang_entry[lang]) {
			return lang_entry[lang]
		}

		if (!langs_missing.value[lang]) langs_missing.value[lang] = {}
		if (!langs_missing.value[lang][lang_key]) langs_missing.value[lang][lang_key] = ""

		return `# ${lang_key} ${lang}`
	}

	async function saveLangEntry(lang_context: string, lang_key: string, lang_id: string, lang_val: string) {
		if (DataStore.holders_vuefire[lang_context].length > 0) {
			const lang_entry = DataStore.holders_vuefire[lang_context].find((el) => el.id === lang_key)
			// console.log('saveLangEntry', lang_key, lang_id, lang_val, lang_entry)
			// if (lang_entry) {
			disabled_reset_langs.value = true

			// Get a new write batch
			// const batch = writeBatch(db)

			const data = <tsAppendableObj>{ [lang_id]: lang_val }

			// for (const langs_id of langs_ids.value) {
			// 	if (
			// 		lang_entry['_' + 'lang_' + langs_id] &&
			// 		lang_entry['lang_' + langs_id] != lang_entry['_' + 'lang_' + langs_id]
			// 	) {
			// 		data['lang_' + langs_id] = lang_entry['_' + 'lang_' + langs_id]
			// 	} else {
			// 		data['lang_' + langs_id] = lang_entry['lang_' + langs_id]
			// 	}

			// 	// console.log(data)
			// 	// const lang_ref = doc(db, 'langs', lang_entry.id)
			// 	// batch.set(lang_ref, lang_entry)
			// }
			data.v = lang_entry ? upVersion(lang_entry.v, 2) : "0.0.0"
			// console.log(data)
			const db_lang_entry = doc(db, "langs", lang_key)
			await updateDoc(db_lang_entry, data)

			// Commit the batch
			// await batch.commit()
			disabled_reset_langs.value = false
			// }
		}
	}

	function upVersion(v: string, at_pos: number) {
		const splits = v.split(".")
		splits[at_pos] = parseInt(splits[at_pos]) + 1

		return splits.join(".")
	}

	async function addNew(lang_key?: any, payload?: any) {
		// console.log(entry_name)
		const db_lang_ref = doc(db, "langs", lang_key)
		const db_lang_entry = <tsAppendableObj>{ ...payload }
		for (const langs_id of langs_ids.value) {
			db_lang_entry[langs_id] = payload[langs_id] ? payload[langs_id] : ""
		}
		console.log("addNew", lang_key, db_lang_entry)
		await setDoc(db_lang_ref, db_lang_entry)
		return true
	}

	// async function addNew(extra?: any, another?: any) {
	// 	const entry_name = prompt(
	// 		'Enter unique language tag' + (extra ? '\n' + extra : ''),
	// 		another ? another : 'wait-what1'
	// 	)
	// 	if (!entry_name) {
	// 		return false
	// 	} else if (DataStore.holders_vuefire[lang_context].find((el) => el.id === entry_name)) {
	// 		return addNew('Another entry was found with this name, \nplease use an unique name', entry_name)
	// 		// return false
	// 	} else if (!entry_name.match(/^(?=.*[a-z])[a-z-0-9]+$/g)) {
	// 		return addNew('Entry can contain any a-z and optional - or 0-9 characters', entry_name)
	// 	}
	// 	// console.log(entry_name)
	// 	const db_lang_ref = doc(db, 'langs', entry_name)
	// 	const db_lang_entry = <tsAppendableObj>{ id: entry_name, v: '0.0.0' }
	// 	for (const langs_id of langs_ids.value) {
	// 		db_lang_entry['lang_' + langs_id] = ''
	// 	}
	// 	await setDoc(db_lang_ref, db_lang_entry)
	// }

	async function duplicateEntry(extra?: any, another?: any, prefill?: any) {
		const entry_name = prompt(
			"Duplicate \n" + another + " \nto a new language tag " + (extra ? "\n" + extra : ""),
			another ? another : "wait-what1",
		)
		if (!entry_name) {
			return false
		} else if (DataStore.holders_vuefire[lang_context].find((el) => el.id === entry_name)) {
			return duplicateEntry("Another entry was found with this name, \nplease use an unique name", entry_name, prefill)
			// return false
		} else if (!entry_name.match(/^(?=.*[a-z])[a-z-0-9]+$/g)) {
			return duplicateEntry("Entry can contain any a-z and optional - or 0-9 characters", entry_name, prefill)
		}
		// console.log(entry_name)
		const db_lang_ref = doc(db, "langs", entry_name)
		const db_lang_entry = <tsAppendableObj>{ id: entry_name, v: "0.0.0" }
		if (prefill) {
			for (const langs_id of langs_ids.value) {
				db_lang_entry[langs_id] = prefill[langs_id]
			}
		} else {
			for (const langs_id of langs_ids.value) {
				db_lang_entry[langs_id] = ""
			}
		}

		await setDoc(db_lang_ref, db_lang_entry)
	}
	async function changeEntryName(extra?: any, another?: any, prefill?: any) {
		const entry_name = prompt(
			"Change \n" + another + " \nto a new language tag " + (extra ? "\n" + extra : ""),
			another ? another : "wait-what1",
		)
		if (!entry_name) {
			return false
		} else if (DataStore.holders_vuefire[lang_context].find((el) => el.id === entry_name)) {
			return duplicateEntry("Another entry was found with this name, \nplease use an unique name", entry_name, prefill)
			// return false
		} else if (!entry_name.match(/^(?=.*[a-z])[a-z-0-9]+$/g)) {
			return duplicateEntry("Entry can contain any a-z and optional - or 0-9 characters", entry_name, prefill)
		}
		// console.log(entry_name)
		const db_lang_ref = doc(db, "langs", entry_name)
		const db_lang_entry = <tsAppendableObj>{ id: entry_name, v: "0.0.0" }
		if (prefill) {
			for (const langs_id of langs_ids.value) {
				db_lang_entry[langs_id] = prefill[langs_id]
			}
		} else {
			for (const langs_id of langs_ids.value) {
				db_lang_entry[langs_id] = ""
			}
		}

		await setDoc(db_lang_ref, db_lang_entry)
		const db_lang_ref_old = doc(db, "langs", prefill.id)
		await deleteDoc(db_lang_ref_old)
	}

	async function deleteEntry(entry_name: string) {
		if (!entry_name) {
			return false
		} else if (DataStore.holders_vuefire[lang_context].find((el) => el.id === entry_name)) {
			// console.log(entry_name)
			const db_lang_ref = doc(db, "langs", entry_name)
			await deleteDoc(db_lang_ref)
		}
	}

	async function undoLangEntry(lang_entry: tsAppendableObj) {
		if (DataStore.holders_vuefire[lang_context].length > 0) {
			// const lang_entry = DataStore.holders_vuefire[lang_context].find((entry: { id: string }) => entry.id === ("lang_" + lang_key))

			if (lang_entry) {
				for (const langs_id of langs_ids.value) {
					if (lang_entry["_" + langs_id] && lang_entry[langs_id] != lang_entry["_" + langs_id]) {
						lang_entry["_" + langs_id] = lang_entry[langs_id]
					}
				}
			}
		}
	}

	const getStructure = computed(() => {
		if (DataStore.holders_vuefire[lang_context].length > 0) {
			const out = <tsAppendableObj>{ rows: DataStore.holders_vuefire[lang_context] }
			// out = DataStore.holders_vuefire[lang_context]

			out["headers"] = [
				{ field: "id", header: "UID", type: "custom", val_type: "string", width: 50 },
				{ field: "v", header: "Version", type: "custom", val_type: "string", width: 50 },
			]
			for (const langs_id of langs_ids.value) {
				out["headers"].push({ field: langs_id, header: langs_id, type: "custom", val_type: "string", width: 100 })
			}
			return out
		}

		return null
	})

	const undoDisabled = computed(() => (lang_entry: tsAppendableObj) => {
		if (DataStore.holders_vuefire[lang_context].length > 0) {
			// const lang_entry = DataStore.holders_vuefire[lang_context].find((entry: { id: string }) => entry.id === ("lang_" + lang_key))

			if (lang_entry) {
				for (const langs_id of langs_ids.value) {
					if (lang_entry["_" + langs_id] && lang_entry[langs_id] != lang_entry["_" + langs_id]) return false
				}
			}
		}
		return true
	})

	return {
		context,

		langs_ids,
		disabled_reset_langs,
		addNew,
		deleteEntry,
		duplicateEntry,
		changeEntryName,
		changeLang,
		reset,
		getLangEntry,
		getHandlebarText,
		getHandlebarLangs,
		saveLangEntry,
		undoLangEntry,
		undoDisabled,
		getStructure,
	}
})

// if (import.meta.hot) {
// 	import.meta.hot.accept(acceptHMRUpdate(useLangsStore, import.meta.hot))
// }
